









































































































































































import { PartnerPracticeApi } from '@/api/partner-practice';
import { ClientAccount } from '@/shared/clients/client-account';
import { PartnerPractice } from '@/shared/partner-practice';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { ClientTitleType } from '@/shared/types/client-title-type';
import { PartnerPracticeType } from '@/shared/types/partner-practice-type';
import { DateTime } from 'luxon';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
const typesModule = namespace('types');
const partnerPracticeApi = new PartnerPracticeApi();

@Component
export default class ClientAccountDetails extends Vue {
    @userModule.Getter('isAdministrator') public isAdministrator!: boolean;

    @typesModule.Getter('activeClientOriginalSourceTypes') private originalSourceTypes!: Array<ClientOriginalSourceType>;
    @typesModule.Getter('activeClientTitleTypes') public titleTypes!: Array<ClientTitleType>;
    @typesModule.Getter('activeClientStatusTypes') public statusTypes!: Array<ClientStatusType>;
    @typesModule.Getter('activePartnerPracticeTypesForCurrentUser') public partnerPractices!: Array<PartnerPracticeType>;

    @Inject('$validator') public $validator!: Validator;
    @Prop({ required: true }) public client!: ClientAccount;

    private endDate = DateTime.fromJSDate(new Date()).minus({ years: 18 }).toJSDate();
    private selectedPartnerPractice: PartnerPractice | null = null;

    private get filteredOriginalSourceTypes(): Array<ClientOriginalSourceType> {
        let originalSourceTypes: Array<ClientOriginalSourceType>;

        if (this.selectedPartnerPractice == null) {
            if (this.client.partnerPracticeId === '00000000-0000-0000-0000-000000000000') {
                originalSourceTypes = [... this.originalSourceTypes.filter((t) => t.isValidForAcquisition)];
            } else {
                return [];
            }
        } else {
            originalSourceTypes = [...this.originalSourceTypes.filter((type) => this.selectedPartnerPractice!.originalSourceTypes.some((t) => t === type.id))];
        }

        return originalSourceTypes.sort((t1, t2) => {
            if (t1.value > t2.value) { return 1; }
            if (t1.value < t2.value) { return -1; }
            return 0;
        });
    }

    public get validationBeforeDate(): string {
        const end = DateTime.fromJSDate(this.endDate!).plus({ days: 1 }).toFormat('dd/MM/yyyy');

        return `${end}`;
    }

    private get originalSourceDescription(): string {
        if (this.client.originalSourceId == null) {
            return '';
        }

        const clientOriginalSourceType = this.originalSourceTypes.find((type) => type.id === this.client.originalSourceId);
        return clientOriginalSourceType == null ? '' : clientOriginalSourceType.value;
    }

    @Watch('client.partnerPracticeId')
    private async onPartnerPracticeIdChanged(): Promise<void> {
        this.selectedPartnerPractice = this.client.partnerPracticeId == null || this.client.partnerPracticeId === '00000000-0000-0000-0000-000000000000'
            ? null
            : await partnerPracticeApi.getPartnerPracticeAsync(this.client.partnerPracticeId);

        this.$emit('partner-practice-changed');
    }

    public async mounted(): Promise<void> {
        this.selectedPartnerPractice = this.client.partnerPracticeId == null || this.client.partnerPracticeId === '00000000-0000-0000-0000-000000000000'
            ? null
            : await partnerPracticeApi.getPartnerPracticeAsync(this.client.partnerPracticeId);
    }
}
